import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction, Range} from 'notebook/tables/excess/FunctionConstants';
import {DivZeroError} from 'notebook/tables/excess/Util';
import toCartesianPoints from 'notebook/tables/excess/util/toCartesianPoints';
import {EvaluablePrimitive} from 'notebook/tables/typed-values/DataTypes';
import {fitSlope, validateData} from 'ui-library/charting/statistics/regression/LinearRegression';
import {mean} from 'ui-library/charting/statistics/StatUtils';
import {NumericCartesianPoint} from 'ui-library/charting/Types';

export default {
  name: 'SLOPE',
  category: FunctionCategory.STATS,
  shortDescription: 'Calculates slope of the linear regression line for a set of points.',
  description:
    'Calculates the slope of the linear regression line for a set of points, ignoring any points that include non-numerical values.',
  params: [
    {
      name: "known_y's",
      type: ArgType.cellRange,
      description: 'An array or cell range of numeric dependent data points.',
    },
    {
      name: "known_x's",
      type: ArgType.cellRange,
      description: 'An array or cell range of numeric independent data points.',
    },
  ],
  eval: (knownYs: Range<EvaluablePrimitive>, knownXs: Range<EvaluablePrimitive>): number => {
    const cartesianPoints = toCartesianPoints(knownYs, knownXs);
    return calculateLinearRegressionSlope(cartesianPoints);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;

function calculateLinearRegressionSlope(points: Array<NumericCartesianPoint>): number {
  const dataError = validateData(points);
  if (dataError) {
    throw new DivZeroError(dataError);
  }
  const meanXs = mean(points.map((point) => point.x));
  const meanYs = mean(points.map((point) => point.y));
  return fitSlope(points, meanXs, meanYs);
}
